import { __exports as backoff } from "../../../../../../_virtual/backoff.js";
import { __require as requireTime } from "./time.js";
var hasRequiredBackoff;
function requireBackoff() {
  if (hasRequiredBackoff) return backoff;
  hasRequiredBackoff = 1;
  var __awaiter = backoff && backoff.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P ? value : new P(function(resolve) {
        resolve(value);
      });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e) {
          reject(e);
        }
      }
      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e) {
          reject(e);
        }
      }
      function step(result) {
        result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  };
  Object.defineProperty(backoff, "__esModule", { value: true });
  backoff.doWithBackoffFailLoudly = backoff.doWithBackoff = void 0;
  const time_1 = requireTime();
  function doWithBackoff(action, backoffPolicy) {
    return __awaiter(this, void 0, void 0, function* () {
      let delay = backoffPolicy.min;
      for (let i = 0; i < backoffPolicy.attempts; i++) {
        try {
          return yield action();
        } catch (e) {
          yield (0, time_1.sleep)(delay);
          delay = Math.min(delay * backoffPolicy.scalar, backoffPolicy.max);
        }
      }
    });
  }
  backoff.doWithBackoff = doWithBackoff;
  function doWithBackoffFailLoudly(action, backoffPolicy) {
    return __awaiter(this, void 0, void 0, function* () {
      let delay = backoffPolicy.min;
      for (let i = 0; i < backoffPolicy.attempts; i++) {
        try {
          return yield action();
        } catch (e) {
          if (i === backoffPolicy.attempts - 1) {
            throw e;
          }
          yield (0, time_1.sleep)(delay);
          delay = Math.min(delay * backoffPolicy.scalar, backoffPolicy.max);
        }
      }
    });
  }
  backoff.doWithBackoffFailLoudly = doWithBackoffFailLoudly;
  return backoff;
}
export {
  requireBackoff as __require
};
//# sourceMappingURL=backoff.js.map
